import React from "react";

export default function BillingItem(props) {
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return (
    <tr onClick={props.onClick}>
      <td>
        <p>{props.date}</p>
      </td>
      <td>
        <p>{props.display_type}</p>
      </td>
      <td>{props.amount}</td>
      <td>{capitalizeFirstLetter(props?.display_desc)}</td>
      <td>{props.payment_processor}</td>
    </tr>
  );
}
